import type { SortDirectionType } from "@rio-cloud/rio-uikit/SortDirection";
import { store } from "@store";
import { getLocale } from "@store/lang/langSlice";

export type TableExportLanguage = "pt-BR" | "en-GB" | "es-ES";

export interface TableExportSort {
  field: string;
  direction: SortDirectionType;
}

export interface TableExportLayout {
  columns: string[];
  sort?: TableExportSort;
}

const EXPORT_LANGUAGES: readonly string[] = ["pt-BR", "en-GB", "es-ES"];
const DEFAULT_EXPORT_LANGUAGE: TableExportLanguage = "pt-BR";

export const resolveExportLanguage = (): TableExportLanguage => {
  const locale = store?.getState ? getLocale(store.getState()) : undefined;
  return locale && EXPORT_LANGUAGES.includes(locale) ? (locale as TableExportLanguage) : DEFAULT_EXPORT_LANGUAGE;
};

export const buildTableExportLayout = (
  columnOrder: readonly string[],
  hiddenColumns: readonly string[],
  sortKey: string | null | undefined,
  sortDirection: SortDirectionType,
  sortKeyMap: Readonly<Record<string, unknown>> = {}
): TableExportLayout => {
  const columns = columnOrder.filter((column) => !hiddenColumns.includes(column));
  if (!sortKey) return { columns };

  const field =
    columnOrder.find((column) => (sortKeyMap[column] ?? column) === sortKey) ??
    (columnOrder.includes(sortKey) ? sortKey : undefined);

  return field ? { columns, sort: { field, direction: sortDirection } } : { columns };
};

export const buildTableExportBody = (layout?: TableExportLayout) => {
  const body: { columns?: string[]; sort?: TableExportSort; language: TableExportLanguage } = {
    language: resolveExportLanguage(),
  };

  const columns = layout?.columns;
  if (Array.isArray(columns) && columns.length) body.columns = columns;
  if (layout?.sort?.field) body.sort = layout.sort;

  return body;
};
